import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { NoticeEmailRouteResolver } from './notice-email-route-resolver.service';
import { ActivatedRoute } from "@angular/router";
import { NoticeService } from "../../../../swaggerServices";
import { formatDocshareLink } from "../util";
import {Subscription} from "rxjs";
import { TenantConfigService } from "../../../shared/services/tenant-config.service";
import { ConfigStateService } from "../../config/config-state.service";
declare var $: any;

const parseMetadata = m => m && m.value != null ? JSON.parse(m.value) : null;

@Component({
    selector: 'app-notice-email',
    templateUrl: './notice-email.component.html',
    styleUrls: ['./notice-email.component.scss'],
    standalone: false
})
export class NoticeEmailComponent implements OnInit, OnDestroy {
  @ViewChild('emailConfirmationModal') emailConfirmationModal: ElementRef;
  emailForm: UntypedFormGroup;
  noticeMeta;
  isLoading: boolean;
  isSaving: boolean;
  hasSent: boolean;
  coverletterLink: string;
  paygFormLink: string;
  sendLinkConfirmation: boolean;
  subscriptions: Subscription[] = [];
  noticeTypeName: string;
  uiConfig: TenantConfigService;
  taxpayerAlias: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private formBuilder: UntypedFormBuilder,
    public config: ConfigStateService,
    private noticeEmailRouteResolver: NoticeEmailRouteResolver,
    private noticeService: NoticeService
  ) {
    this.emailForm = this.formBuilder.group({
      mailTo: ['', [Validators.required]],
      mailCc: [''],
      subject: ['', Validators.required],
      body: ['', Validators.required],
    });
  }

  ngOnInit() {
    this.subscriptions.push(this.activatedRoute.data.subscribe(res => {
      const { group, docshareBaseUrl } = res.noticeMetadata;
      let noticeTemplate = res.noticeMetadata.RubixPaygTaxpayerEmailTemplate;
      let noticeEmailReadyToSend = res.noticeMetadata.RubixPaygTaxpayerEmailReadyToSend;
      let noticeCoverLetterId = res.noticeMetadata.RubixPaygCoverLetterDocshareId;

      if (group === "NOA") {
        this.noticeTypeName = "NOA";
        noticeTemplate = res.noticeMetadata.RubixNoaTaxpayerEmailTemplate;
        noticeEmailReadyToSend = res.noticeMetadata.RubixNoaTaxpayerEmailReadyToSend;
        noticeCoverLetterId = res.noticeMetadata.RubixNoaCoverLetterDocshareId;
      }

      if (group === "AS") {
        this.noticeTypeName = "PAYG";
        this.paygFormLink = formatDocshareLink(docshareBaseUrl, parseMetadata(res.noticeMetadata.RubixPaygFormDocshareId));
      }

      const { mailTo, mailCc, subject, body } = parseMetadata(noticeTemplate);
      this.hasSent = parseMetadata(noticeEmailReadyToSend) || false;
      this.sendLinkConfirmation = parseMetadata(res.noticeMetadata.RubixLINKSendConfirmationEmail) || true;
      this.noticeMeta = noticeTemplate;
      this.emailForm.setValue({ mailTo, mailCc, subject, body });
      this.coverletterLink = formatDocshareLink(docshareBaseUrl, parseMetadata(noticeCoverLetterId));
    }));
    this.subscriptions.push(
      this.config.loadConfig().subscribe(config => {
        this.uiConfig = new TenantConfigService(config);
        this.taxpayerAlias = this.uiConfig.config.taxpayerAlias;
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  onSubmit() {
    $(this.emailConfirmationModal.nativeElement).modal('show');
  }

  sendEmail() {
    this.isLoading = true;
    this.noticeService.updateNoticeMetadata(this.noticeMeta.id, { value: JSON.stringify(this.emailForm.value) }).subscribe(() => {
      this.noticeService.createEmailExecution(this.noticeMeta.noticeId, { sendLinkConfirmation: this.sendLinkConfirmation }).subscribe(() => {
        $(this.emailConfirmationModal.nativeElement).modal('hide');
        this.hasSent = true;
        this.isLoading = false;
      }, e => {
        this.isLoading = false;
      });
    }, e => {
      this.isLoading = false;
    });
  }

  saveEmail() {
    this.isSaving = true;
    event.preventDefault();
    this.noticeService.updateNoticeMetadata(this.noticeMeta.id, { value: JSON.stringify(this.emailForm.value) }).subscribe(data => {
      this.isSaving = false;
    }, e => {
      this.isSaving = false;
    });
  }
}
